<template>
  <div class="container" style="width: 1280px;">
    <div class="one" :class="{'gudingo':guding}">
      <div class="item" v-for="(item,index) in list" :style="{border: '1px solid '+item.color}"
        @click="change(index,item.type)">
        <div :style="{color: index == n?'#FFFFFF':item.color,backgroundColor: index == n?item.color:'transparent'}"
          style="border-radius: 9px;">
          {{item.name}}
          <span v-if="item.num!=0" :style="{color: index == n?'#FFFFFF':item.color}"
            style="font-size: 16px;margin-left: 10px;">
            {{'('+item.num+ (item.yixuan == 0?'':'/'+item.yixuan)+ ')'}}
          </span>
          <el-tooltip effect="dark" placement="bottom">
            <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
              <div style="padding-left:20px;" v-if="item.type == 'cyc'">
                <div class="infofont">1、“冲一冲”志愿个数{{batch.cycmin}}-{{batch.cycmax}}个之间，建议选择{{batch.cycavg}}个左右。</div>
                <div class="infofont">2、建议每个录取概率志愿数尽量不超过{{batch.cyctong}}个，尽量多选择录取概率在{{batch.cycrate1}}%-{{batch.cycrate2}}%之间的志愿，录取概率越高，志愿尽量多选。</div>
                <!-- <div class="infofont">3、志愿选择时建议每个录取概率院校数不超过3个，不同录取概率从低到高分布均匀，尽量每个录取概率都要选到，拉开志愿合理梯度。</div> -->
              </div>
              <div style="padding-left:20px;" v-if="item.type == 'wyw'">
                <div class="infofont">1、“稳一稳”志愿个数{{batch.wywmin}}-{{batch.wywmax}}个之间，建议选择{{batch.wywavg}}个左右。</div>
                <div class="infofont">2、志愿选择时建议不同录取概率从低到高分布均匀，尽量每个录取概率都要选到，拉开志愿合理梯度。</div>
                <div class="infofont">3、为保证志愿合理性志愿选择时，每个录取概率的志愿尽量不超过{{batch.wywtong}}个，备选志愿录取位次越和自己高考位次接近的尽量多选择。</div>
              </div>
              <div style="padding-left:20px;" v-if="item.type == 'byb'">
                <div class="infofont">1、“保一保”志愿个数{{batch.bybmin}}-{{batch.bybmax}}个之间，建议选择{{batch.bybavg}}个左右。</div>
                <div class="infofont">2、志愿选择时建议不同录取概率从低到高分布均匀，尽量每个录取概率都要选到，拉开志愿合理梯度。</div>
                <div class="infofont">3、为保证志愿合理性志愿选择时，每个录取概率的志愿尽量不超过{{batch.bybtong}}个，备选志愿录取位次越和自己高考位次接近的尽量多选择。</div>
              </div>
              <div style="padding-left:20px;" v-if="item.type == 'dyd'">
                <div class="infofont">1、“垫一垫”志愿个数{{batch.dydmin}}-{{batch.dydmax}}个之间，建议选择{{batch.dydavg}}个左右。</div>
                <div class="infofont">2、志愿选择时建议不同录取概率从低到高分布均匀，尽量每个录取概率都要选到，拉开志愿合理梯度。</div>
                <div class="infofont">3、为保证志愿合理性志愿选择时，每个录取概率的志愿尽量不超过{{batch.dydtong}}个，备选志愿录取位次越和自己高考位次接近的尽量多选择。</div>
                <div class="infofont">4、“垫一垫”志愿是考生志愿的最后保障，垫一垫中录取概率最大的备选志愿，建议考生选择{{batch.dydjynum}}个以上。</div>
              </div>
            </div>
            <img v-if="index == n" src="../../src/assets/img/info.png" alt="" class="imginfo">
            <img v-if="item.type == 'cyc'&&index != n" src="../../src/assets/img/infocyc.png" alt="" class="imginfo">
            <img v-if="item.type == 'wyw'&&index != n" src="../../src/assets/img/infowyw.png" alt="" class="imginfo">
            <img v-if="item.type == 'byb'&&index != n" src="../../src/assets/img/infobyb.png" alt="" class="imginfo">
            <img v-if="item.type == 'dyd'&&index != n" src="../../src/assets/img/infodyd.png" alt="" class="imginfo">
          </el-tooltip>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      allData: {
        type: Object
      },
      guding: {
        type: Boolean
      }
    },
    watch: {
      allData(newV, oldV) {
        this.list[0].num = newV.sun_cyc
        this.list[1].num = newV.sun_wyw
        this.list[2].num = newV.sun_byb
        this.list[3].num = newV.sun_dyd
      }
    },
    data() {
      return {
        n: 0,
        type: 'cyc',
        list: [{
            name: "冲一冲",
            color: "#FF513E",
            type: "cyc",
            num: 0,
            yixuan: 0
          },
          {
            name: "稳一稳",
            color: "#fe9b0e",
            type: "wyw",
            num: 0,
            yixuan: 0
          },
          {
            name: "保一保",
            color: "#0081cc",
            type: "byb",
            num: 0,
            yixuan: 0
          },
          {
            name: "垫一垫",
            color: "#00B54F",
            type: "dyd",
            num: 0,
            yixuan: 0
          }
        ],
        batch:this.$utils.getlocalStorage("userZhiYuanBatch")
      };
    },
    computed: {},
    methods: {
      change(index, type) {
        this.n = index
        this.type = type
        this.$emit("changeType", type);
      },
      changedata() {
        this.list[this.n].yixuan = this.$utils.getlocalStorage("ZhiYuan" + this.type).ids.length
      },
      changedataAll(type) {
        if (type) {
          this.type = type
          if (type == 'cyc') {
            this.n = 0
          } else if (type == 'wyw') {
            this.n = 1
          } else if (type == 'byb') {
            this.n = 2
          } else if (type == 'dyd') {
            this.n = 3
          }
        }
      }
    },
    mounted() {

    },
    created() {}
  };
</script>
<style scoped>
  .infofont {
    color: white;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .imginfo {
    margin-top: 5px;
    float: right;
    margin-right: 20px;
  }

  .one {
    margin-top: 10px;
    justify-content: space-between;
    width: 100%;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
  }

  .gudingo div {
    flex-shrink: 0;
  }

  .item {

    width: 24%;
    text-align: center;
    line-height: 35px;
    font-size: 16px;
    font-weight: 800;
    height: 35px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 10px;
  }

  .gudingo {
    position: fixed;
    top: 70px;
    left: ;
    -webkit-transform: translate(0);
    transform: translate(0);
    margin-top: 0 !important;
    width: 1280px !important;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/tiabaoType.vue